function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.068 0C3.688 0 0 3.519 0 7.86V16l8.067-.008c4.38 0 7.933-3.654 7.933-7.994S12.444 0 8.068 0z",
  fill: "#000"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.146 3.043a4.928 4.928 0 0 0-4.223 2.38 4.835 4.835 0 0 0-.1 4.813l-.89 2.836 3.196-.715c1.83.816 3.976.45 5.424-.927a4.84 4.84 0 0 0 1.158-5.332 4.917 4.917 0 0 0-4.56-3.055h-.005z",
  fill: "#FFF9AE"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.99 10.93a4.945 4.945 0 0 1-5.861 1.42l-3.195.723 3.252-.38a4.945 4.945 0 0 0 6.417-1.28 4.838 4.838 0 0 0-.556-6.462 4.835 4.835 0 0 1-.056 5.98z",
  fill: "#00AEEF"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.716 10.004a4.938 4.938 0 0 1-5.68 2.018l-3.102 1.051 3.195-.717c2.275 1.019 4.96.185 6.241-1.938a4.841 4.841 0 0 0-1.228-6.366 4.836 4.836 0 0 1 .574 5.952z",
  fill: "#00A94F"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.117 10.343a4.847 4.847 0 0 1 1.76-5.883 4.952 4.952 0 0 1 6.173.489c-1.558-2.026-4.429-2.521-6.586-1.135a4.846 4.846 0 0 0-1.64 6.421l-.89 2.837 1.183-2.729z",
  fill: "#F15D22"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.824 10.236a4.841 4.841 0 0 1 1.134-6.027 4.952 4.952 0 0 1 6.185-.157 4.95 4.95 0 0 0-6.658-.433 4.842 4.842 0 0 0-.964 6.541l-.585 2.913.888-2.838z",
  fill: "#D0232B"
});

var SvgDiscourse = function SvgDiscourse(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
};

export default __webpack_public_path__ + "static/media/discourse.ebc67701.svg";
export { SvgDiscourse as ReactComponent };